import { Currency } from '@/core/currency/interfaces';

const GNF: Currency = {
    name: 'Guinean Franc',
    demonym: 'Guinean',
    majorSingle: 'Franc',
    majorPlural: 'Francs',
    codeNumeric: '324',
    symbol: 'FG',
    symbolNative: 'FG',
    minorSingle: 'Centime',
    minorPlural: 'Centimes',
    ISOdigits: 0,
    decimals: 0,
    numToBasic: 100,
    code: 'GNF',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default GNF;
